import React, { Component } from 'react'
import { Button, Collapse, Form, Row } from 'reactstrap'
import { BeatLoader } from 'react-spinners'
import { 
  Email, 
  ErrorMessage, 
  FirstName, 
  LastName, 
  SaveButton, 
  Sfid, 
  Username,
  Password,
  Name,
  State,
  Period, } from './ManagePane/InfoCard/ActionBlockComponents'
import validateFields from '../../../helpers/users/manageUsers/validateFields';
import addNewUser from '../../../helpers/users/manageUsers/addNewUser';
import pingPasswordFunc from '../../../helpers/users/manageUsers/pingPasswordFunc';

class AddForm extends Component {

  state = {
    firstName: '',
    lastName: '',
    username: '',
    email: '',
    sfid: '',
    saving: false,
    error: '',
    saved: false,
    validation: {},
    changed: false,
    password: '',
    manualPassword: false,
    name: '',
    state: '',
    period: '',    
  }

  oChg = ({target}) => {
    let { validation } = this.state
    if (validation[target.name]) {
      validation = {}
    }
    this.setState({[target.name]: target.value, saved: false, validation, changed: true})
  }

  oSave = () => {
    const { parentAccount, role, accountType } = this.props
    this.setState({saving: true, error: ''})
    const validationErr = validateFields({role,}, this.state, accountType)
    if (validationErr) {
      this.setState({validation: validationErr, saving: false})
    } else {
      addNewUser(Object.assign({},this.state), role, parentAccount, accountType)
        .then(() => this.setState({saving: false, saved: true, error: ''}))
        .catch((err) => {
          const error = err === 'Email or username already in use.' ? err : 'Error saving.'
          this.setState({saving: false, error,})
        })
    }
  }

  reset = () => {
    this.setState({
      firstName: '',
      lastName: '',
      username: '',
      email: '',
      sfid: '',
      saving: false,
      error: '',
      saved: false,
      validation: {},
      changed: false,
      password: '',
      manualPassword: false,
      name: '',
      state: '',
      period: '',  
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.parentAccount !== prevProps.parentAccount) {
      this.reset()
    }
  }

  manualPasswordToggle = () => {
    const { role } = this.props
    !this.state.manualPassword && pingPasswordFunc(role).catch(err => console.log(err))
    this.setState({manualPassword: !this.state.manualPassword})
  }

  componentDidMount() {
    const { role } = this.props
    pingPasswordFunc(role).catch(err => console.log(err))
  }

  render() {
    const { user, accountType, collection, role, parentAccount } = this.props
    const { 
      firstName, 
      lastName, 
      username, 
      email, 
      sfid, 
      saving, 
      saved, 
      validation, 
      error,
      changed,
      password, 
      manualPassword,
      name,
      state,
      period, } = this.state
    return (
      <Form className='add-user-form'>
        {role &&
          <div>
            <FirstName oChg={this.oChg} val={firstName} err={validation} saved={saved} />
            <LastName oChg={this.oChg} val={lastName} err={validation} saved={saved} />
            {role === 'Student' &&
              <Username oChg={this.oChg} val={username} err={validation} saved={saved}/>
            }
            <Email oChg={this.oChg} val={email} err={validation} saved={saved}/>
          </div>
        }
        {!role &&
          <div>
            <Name oChg={this.oChg} val={name} err={validation} saved={saved} />
            {accountType === 'District' &&
              <State oChg={this.oChg} val={state} err={validation} saved={saved} />
            }
            {accountType === 'Class' &&
              <Period oChg={this.oChg} val={period} err={validation} saved={saved} />
            }
          </div>
        }
        {user && user.role === 'Super Administrator' &&
          <Sfid oChg={this.oChg} val={sfid} saved={saved}/>
        }

        
        {role &&
          <Collapse isOpen={!!manualPassword}>
            <Password oChg={this.oChg} val={password} err={validation} saved={saved}/>
            
          </Collapse>
        }
        {role &&
          <div className='add-form-buttons'>

            <Collapse isOpen>
            <Button 
                onClick={this.manualPasswordToggle}
                disabled={!!saved}
              >
                {!!manualPassword ? 'Cancel' : 'Manually Create Password' }
              </Button>
              </Collapse>

            <SaveButton changed={changed} oSave={this.oSave} disabled={!!saved}>
              {saving 
                ? <BeatLoader loading={saving} /> 
                : (saved ? 'Saved' : 'Save')
              }
            </SaveButton>
            {saved &&
              <Button onClick={this.reset}>Add Another {role}</Button>
            }
          </div>
        }
        {!role &&
          <SaveButton changed={changed} oSave={this.oSave} disabled={!!saved}>
            {saving 
              ? <BeatLoader loading={saving} /> 
              : (saved ? 'Saved' : 'Save')
            }
          </SaveButton>
        }
        
        {Object.keys(validation).length > 0 &&
          <ErrorMessage>{validation[Object.keys(validation)[0]]}</ErrorMessage>
        }
        {error &&
          <ErrorMessage>{error}</ErrorMessage>
        }
      </Form>
    )
  }
}

export default AddForm


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/AddForm.js